export default "__VITE_ASSET__nO7cmAqX__"